<template>
    <jet-authentication-card>
        <template #logo>
            <img src="/img/osm-logo-white.svg" alt="OSM" class="mt-4" />
        </template>

        <jet-validation-errors class="mb-4" />
        <div
            v-if="text"
            class="relative px-4 py-3 my-5 bg-red-100 border border-red-400 rounded text-white-700"
            role="alert"
        >
            <span class="block sm:inline"
                >A user with this email address already exist in Virtual
                Coach.</span
            >
            <a href="/login" class="font-bold text-pink-600 underline">
                Please login here!</a
            >
        </div>

        <form @submit.prevent="submit">
            <div v-if="step === 1">
                <div>
                    <jet-label for="name" value="Nome" />
                    <jet-input
                        id="name"
                        type="text"
                        class="block w-full mt-1"
                        v-model="form.name"
                        required
                        autofocus
                        autocomplete="name"
                    />
                    <div
                        v-if="nameError.length > 0"
                        class="my-1 text-sm font-semibold text-center text-red-500"
                    >
                        {{ nameError }}
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label for="last_name" value="Cognome" />
                    <jet-input
                        id="last_name"
                        type="text"
                        class="block w-full mt-1"
                        required
                        v-model="form.last_name"
                    />
                </div>

                <div class="mt-4">
                    <jet-label for="username" value="Nickname" />
                    <jet-input
                        id="username"
                        type="text"
                        class="block w-full mt-1"
                        required
                        v-model="form.username"
                    />
                </div>

                <div class="mt-4">
                    <jet-label for="email" value="Email" />
                    <jet-input
                        id="email"
                        type="email"
                        class="block w-full mt-1"
                        required
                        v-model="form.email"
                    />
                    <div
                        v-if="emailError.length > 0"
                        class="my-1 text-sm font-semibold text-center text-red-500"
                    >
                        {{ emailError }}
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label for="phone" value="Phone" />
                    <jet-input
                        id="phone"
                        type="text"
                        class="block w-full mt-1"
                        required
                        v-model="form.phone"
                    />
                    <div
                        v-if="phoneError.length > 0"
                        class="my-1 text-sm font-semibold text-center text-red-500"
                    >
                        {{ phoneError }}
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label for="password" value="Password" />
                    <jet-input
                        id="password"
                        type="password"
                        class="block w-full mt-1"
                        v-model="form.password"
                        required
                        autocomplete="new-password"
                    />
                    <div
                        v-if="passwordError.length > 0"
                        class="my-1 text-sm font-semibold text-center text-red-500"
                    >
                        {{ passwordError }}
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label
                        for="password_confirmation"
                        value="Conferma Password"
                    />
                    <jet-input
                        id="password_confirmation"
                        type="password"
                        class="block w-full mt-1"
                        v-model="form.password_confirmation"
                        required
                        autocomplete="new-password"
                    />
                </div>

                <div class="mt-4">
                    <jet-label for="terms">
                        <div class="flex items-center">
                            <jet-checkbox
                                name="terms"
                                id="terms"
                                v-model="form.terms"
                            />

                            <div class="ml-2">
                                Ho letto e accetto la
                                <a
                                    target="_blank"
                                    :href="route('privacy-policy')"
                                    class="text-sm text-gray-600 underline hover:text-gray-900"
                                    >Privacy Policy</a
                                >
                            </div>
                        </div>
                    </jet-label>
                </div>

                <div class="flex items-center justify-start my-4">
                    <a
                        href="/cookie-policy"
                        target="blank"
                        class="text-sm text-black underline hover:text-gray-900"
                    >
                        Leggi la Cookie Policy
                    </a>
                </div>

                <div class="flex items-center justify-start my-4">
                    <inertia-link
                        :href="route('login')"
                        class="text-sm text-gray-600 underline hover:text-gray-900"
                    >
                        Sei già registrato?
                    </inertia-link>
                </div>
                <jet-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    Registrati
                </jet-button>

                <!-- <button
                    :disabled="!isComplete"
                    @click="nextStep"
                    class="inline-flex items-center mt-2 px-8 py-2 bg-gray-700 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                >
                    Next
                </button> -->
            </div>

            <div v-if="step === 2">
                <div class="mt-4">
                    <jet-label for="city" value="Your City" />
                    <div class="relative mb-6">
                        <select
                            required
                            v-model="city"
                            class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-3 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                        >
                            <option
                                v-for="province in provinces"
                                :key="province.id"
                                :value="province.id"
                            >
                                {{ province.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label
                        for="city"
                        value="What would you like to sell?"
                    />
                    <div class="relative mb-6">
                        <div>
                            <div
                                v-for="(input, k) in inputs"
                                :key="k"
                                class="flex items-center my-4"
                            >
                                <div class="w-full">
                                    <input
                                        v-model="input.message"
                                        :name="`message${k}`"
                                        minlength="1"
                                        class="block w-full p-3 mt-1 border border-solid border-gray-300 rounded shadow appearance-none focus:outline-none"
                                        type="text"
                                        placeholder="nome prodotto..."
                                    />
                                    <input
                                        type="hidden"
                                        name="keyFeature"
                                        :value="k"
                                    />
                                </div>
                                <div class="mx-4 mt-1.5">
                                    <span
                                        @click="add(k)"
                                        v-show="k == inputs.length - 1"
                                        class="  text-lg font-bold text-green-700 bg-green-200 border border-green-700 rounded-full cursor-pointer text-center"
                                        ><i class="font-semibold material-icons"
                                            >add</i
                                        ></span
                                    >
                                </div>
                                <span
                                    @click="remove(k)"
                                    v-show="k || (!k && inputs.length > 1)"
                                    class="pt-[0.4rem] px-[0.4rem] text-lg font-bold text-red-700 bg-red-200 border border-red-700 rounded-full cursor-pointer text-center"
                                    ><i class="font-semibold material-icons"
                                        >remove</i
                                    ></span
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label for="city" value="What would you like to buy?" />
                    <div class="relative mb-6">
                        <div>
                            <div
                                v-for="(look, id) in looks"
                                :key="id"
                                class="w-full py-1"
                            >
                                <div class="flex items-center py-1">
                                    <div class="w-full">
                                        <input
                                            type="text"
                                            v-model="look.product"
                                            :name="`product${id}`"
                                            minlength="1"
                                            class="w-full p-2 text-black bg-white border border-gray-300 rounded-md focus:outline-none"
                                            placeholder="nome prodotto.."
                                        />
                                        <input
                                            type="hidden"
                                            name="keyLook"
                                            :value="id"
                                        />
                                    </div>
                                    <div class="mx-4 mt-1.5">
                                        <span
                                            @click="addLooks(id)"
                                            v-show="id == looks.length - 1"
                                            class="pt-[0.6rem] pb-[0.1rem] px-[0.4rem] text-lg font-bold text-green-700 bg-green-200 border border-green-700 rounded-full cursor-pointer text-center"
                                            ><i
                                                class="font-semibold material-icons"
                                                >add</i
                                            ></span
                                        >
                                    </div>
                                    <span
                                        @click="removeLooks(id)"
                                        v-show="id || (!id && looks.length > 1)"
                                        class="pt-[0.4rem] px-[0.4rem] text-lg font-bold text-red-700 bg-red-200 border border-red-700 rounded-full cursor-pointer text-center"
                                        ><i class="font-semibold material-icons"
                                            >remove</i
                                        ></span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <jet-label
                        for="Country"
                        value="Countries I would like to work"
                    />
                    <div
                        class="block w-full p-3 mt-1 border border-solid border-gray-300 rounded shadow appearance-none focus:outline-none"
                        @click="dropdown = !dropdown"
                    >
                        <div>Select Countries</div>
                    </div>
                    <div
                        v-show="dropdown"
                        class="z-40 w-full h-48 p-1 overflow-y-scroll border rounded-b-md"
                    >
                        <ul>
                            <li
                                v-for="country in countries"
                                :key="country.id"
                                class="flex p-2 cust_check"
                            >
                                <input
                                    type="checkbox"
                                    :id="country.code"
                                    :value="country.name"
                                    v-model="selectedCountries"
                                />
                                <label
                                    class="px-3 py-2 font-bold text-gray-600 capitalize bg-white border border-gray-500 rounded-lg cursor-pointer"
                                >
                                    {{ country.name }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label
                        for="Regions"
                        value="Regions I would like to work"
                    />
                    <div
                        class="block w-full p-3 mt-1 border border-solid border-gray-300 rounded shadow appearance-none focus:outline-none"
                        @click="regionDropdown = !regionDropdown"
                    >
                        <div>Select Regions</div>
                    </div>
                    <div
                        v-show="regionDropdown"
                        class="z-40 w-full h-48 p-1 overflow-y-scroll border rounded-b-md"
                    >
                        <ul>
                            <li
                                v-for="region in regions"
                                :key="region.id"
                                class="flex p-2 cust_check"
                            >
                                <input
                                    type="checkbox"
                                    :id="region.id"
                                    :value="region.name"
                                    v-model="selectedRegions"
                                />
                                <label
                                    class="px-3 py-2 font-bold text-gray-600 capitalize bg-white border border-gray-500 rounded-lg cursor-pointer"
                                >
                                    {{ region.name }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label for="Job" value="Are you looking for a job?" />
                    <div class="relative mb-6">
                        <div class="w-full flex flex-row pr-4">
                            <input
                                name="radio"
                                type="radio"
                                v-model="job_status1"
                                value="yes"
                                :class="{
                                    'bg-iconblue  border-white text-white placeholder-white':
                                        darkMode,
                                    'text-black': !darkMode,
                                }"
                            />
                            <label class="pl-2 pr-6">yes</label>
                            <input
                                name="radio"
                                type="radio"
                                v-model="job_status2"
                                value="no"
                                :class="{
                                    'bg-iconblue  border-white text-white placeholder-white':
                                        darkMode,
                                    'text-black': !darkMode,
                                }"
                            />
                            <label class="pl-2">no</label>
                        </div>
                    </div>
                </div>
                <div v-if="job_status1 == 'yes'" class="mt-4">
                    <jet-label for="Provinces" value="Provinces" />
                    <div
                        class="block w-full p-3 mt-1 border border-solid border-gray-300 rounded shadow appearance-none focus:outline-none"
                        @click="provinceDropdown = !provinceDropdown"
                    >
                        <div>Select Provinces</div>
                    </div>
                    <div
                        v-show="provinceDropdown"
                        class="z-40 w-full h-48 p-1 overflow-y-scroll border rounded-b-md"
                    >
                        <ul>
                            <li
                                v-for="province in provinces"
                                :key="province.id"
                                class="flex p-2 cust_check"
                            >
                                <input
                                    type="checkbox"
                                    :id="province.id"
                                    :value="province.name"
                                    v-model="selectedProvinces"
                                />
                                <label
                                    class="px-3 py-2 font-bold text-gray-600 capitalize bg-white border border-gray-500 rounded-lg cursor-pointer"
                                >
                                    {{ province.name }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>
                <span
                    @click="prevStep"
                    class="inline-flex items-center mt-2 px-8 py-2 bg-gray-700 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150"
                >
                    Previous
            </span>
                <jet-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    Registrati
                </jet-button>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo";
import JetButton from "@/Jetstream/Button";
import JetInput from "@/Jetstream/Input";
import JetCheckbox from "@/Jetstream/Checkbox";
import JetLabel from "@/Jetstream/Label";
import JetValidationErrors from "@/Jetstream/ValidationErrors";
import axios from "axios";
import { countries } from "countries-list";
import "material-icons/iconfont/material-icons.css";

export default {
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
    },

    data() {
        return {
            form: this.$inertia.form({
                name: "",
                last_name: "",
                username: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: "",
                terms: false,
            }),
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            text: "",
            step: 1, // Tracks the current step
            provinces: "",
            city: "",
            countries: Object.values(countries).map((country) => ({
                name: country.name,
                code: country.iso2,
            })),
            dropdown: false,
            regionDropdown: false,
            provinceDropdown: false,
            selectedCountries: [],
            regions: "",
            selectedRegions: [],
            job_status1: "",
            job_status2: "",
            selectedProvinces: [],
            inputs: [
                {
                    message: null,
                },
            ],
            feature_product: false,
            looking_product: false,
            looks: [
                {
                    high_priority: false,
                    product: null,
                },
            ],
            form: {
                processing: false, // or whatever your initial value should be
            },
        };
    },

    mounted() {
        this.fetchData();
    },
    computed: {
        isComplete() {
            return (
                this.form.name &&
                this.form.last_name &&
                this.form.username &&
                this.form.email &&
                this.form.phone &&
                this.form.password &&
                this.form.password_confirmation
            );
        },
    },
    methods: {
        addLooks() {
            this.looks.push({ high_priority: false, product: null });
        },
        removeLooks(value) {
            this.looks.splice(value, 1);
        },
        add() {
            this.inputs.push({ message: null });
        },
        remove(index) {
            this.inputs.splice(index, 1);
        },
        nextStep() {
            this.step = 2; // Move to step 2
        },
        prevStep() {
            this.step = 1; // Move back to step 1
        },
        fetchData() {
            let custObj = this;
            const headers = {
                "Content-Type": "application/json",
            };
            axios
                .get("/api/enquiry-data", { headers })
                .then((response) => {
                    custObj.provinces = response.data.data.provinces;
                    custObj.regions = response.data.data.regions;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        submit() {
           
            // this.form.post('api/user/register'), {
            //     onFinish: () => this.form.reset('password', 'password_confirmation'),
            // }
            let custObj = this;
            const headers = {
                "Content-Type": "application/json",
            };
            axios
                .post(
                    "/api/user/register",
                    {
                        name: this.form.name,
                        last_name: this.form.last_name,
                        email: this.form.email,
                        phone: this.form.phone,
                        password: this.form.password,
                        password_confirmation: this.form.password_confirmation,
                        username: this.form.username,
                        terms: this.form.terms,
                        feature:JSON.stringify(this.inputs),
                        looking:JSON.stringify(this.looks),
                        city:this.city,
                        countries:this.selectedCountries,
                        regions:this.selectedRegions,
                        province:this.job_status1 == 'yes' ? this.selectedProvinces : null,
                        job_status:this.job_status1 == 'yes' ? 'yes' : 'no'

                    },
                    { headers }
                )
                .then(function (response) {
                    if (response.data.message) {
                        custObj.text = response.data.message;
                    } else {
                        window.location = "/login";
                    }
                })
                .catch(function (error) {
                    custObj.nameError = "";
                    custObj.emailError = "";
                    custObj.phoneError = "";
                    custObj.passwordError = "";

                    if (error.response.data.name) {
                        custObj.nameError = "Name field must be required";
                    } else if (error.response.data.email) {
                        if (
                            error.response.data.email[0] === "validation.unique"
                        ) {
                            custObj.emailError = "Email-Id already exists!";
                        } else {
                            custObj.emailError = "Valid email id is required";
                        }
                    } else if (error.response.data.phone) {
                        custObj.phoneError = "Phone field must be required";
                    } else if (error.response.data.password) {
                        custObj.passwordError =
                            "Minimum 8 character requied for password";
                    }
                });
        },
    },
};
</script>
